var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"address-item"},_vm._l((_vm.addressLinesList),function(item,n){return _c('li',{key:(item + "-" + n),staticClass:"address-item__line",domProps:{"innerHTML":_vm._s(item)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }